import { render, staticRenderFns } from "./DisplayProductImageNew.vue?vue&type=template&id=049072a8"
import script from "./DisplayProductImageNew.vue?vue&type=script&lang=js"
export * from "./DisplayProductImageNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports